import { Drawer } from '@mui/material';
import { SidebarContent } from '../Menu';
import { useState, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import './sidebar.css'

const COLLAPSED_DRAWER_WIDTH = 65;
export const Sidebar = ({ drawerWidth, mobileOpen, recalcularAnchoDrawer, onDrawerToggle, abierto }) => {

    const { user } = useContext(AuthContext);

    // Si el perfil es 2, no renderizar la Sidebar
    if (user?.idPerfil === 2) {
        return null;
    }

    const finalWidth = abierto ? drawerWidth : COLLAPSED_DRAWER_WIDTH;

    return (
        <>
            {/* MOBILE */}
            <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={onDrawerToggle}
                ModalProps={{ keepMounted: true }}
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth }
                }}
            >
                <SidebarContent abrirCerrar={recalcularAnchoDrawer} abierto={abierto} />
            </Drawer>

            {/* DESKTOP */}
            <Drawer
                variant="permanent"
                sx={(theme) => ({
                    display: { xs: 'none', sm: 'block' },
                    '& .MuiDrawer-paper': {
                        boxSizing: 'border-box',
                        width: finalWidth,
                        overflowX: 'hidden',
                        transition: theme.transitions.create('width', {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.enteringScreen,
                        }),
                    }
                })}
                open
            >
                <SidebarContent abrirCerrar={recalcularAnchoDrawer} abierto={abierto} />
            </Drawer>
        </>
    );
};
